module.exports = __webpack_public_path__ + "static/media/bg.0c174a0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg.mp4
// module id = x/g7
// module chunks = 1